export default "__VITE_ASSET__Clk1WpHk__"